import React from "react";
import classes from "./styles/style.module.css";
import { useNavigate } from "react-router";
import useLoginActions from "../../../assets/Hooks/Login";

const ListElement = ({ label, icon, action, link, linkNewTab, newItem }) => {
  const navigate = useNavigate();
  const { handleLogout } = useLoginActions();

  const clickHandler = (action, link) => {
    if (link !== "") {
      if (link.startsWith("https://", 0) || link.startsWith("http://", 0)) {
        if (linkNewTab) {
          window.open(link, "_blank");
        } else {
          window.location.href = link;
        }
      } else {
        navigate(link);
      }
    } else if (action) {
      if (action === "logOut") {
        handleLogout();
      }
    }
  };

  return (
    <div className="col-3 text-center px-0">
      <div
        className={classes.listElementContainer}
        onClick={() => clickHandler(action, link)}
      >
        {
          newItem && <div className={classes.new}>جدید</div>
        }
        <div className={classes.iconContainer}>
          <img src={icon} alt={`${label} ${Math.random() * 1000}`} />
        </div>
        <p>{label}</p>
      </div>
    </div>
  );
};

export default ListElement;
